/* eslint-disable */
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { compose } from 'redux';
import UserMenu from '../../Components/UserMenu/UserMenu.component';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import ReportPageSidebarPropTypes from './Report.page.sidebar.props';
import reportPageStyles from './Report.page.styles';

/**
 * ReportPageSidebarComponent
 * @export
 * @class ReportPageSidebarComponent
 * @extends {React.Component<ReportPageSidebarComponentComposedProps, ReportPageSidebarComponentState>}
 */
export class ReportPageSidebarComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<ReportPageSidebarComponentProps>}
   * @memberof ReportPageSidebarComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`ReportPageSidebar`}
   * @memberof ReportPageSidebarComponent
   */
  static displayName = `ReportPageSidebar`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof ReportPageSidebarComponent
   */
  static propTypes = ReportPageSidebarPropTypes;

  /**
   * Data specific to the `<ReportPageSidebar />` instance
   * @type {ReportPageSidebarComponentState}
   * @memberof ReportPageSidebarComponent
   */
  state = {};

  /**
   * Render the sidebar
   * @returns {React.Component} The rendered `<OrderPageSidebar />`
   * @memberof ReportPageSidebarComponent
   */
  render() {
    return <UserMenu showAvatar={false} />;
  }
}

/** @type {React.ComponentClass<ReportPageSidebarComponentProps>} */
const ReportPageSidebar = compose(withStyles(themeCreateInjectableStyles(reportPageStyles), { withTheme: true }))(ReportPageSidebarComponent);

export default ReportPageSidebar;
